import { render, staticRenderFns } from "./images.vue?vue&type=template&id=105bde4e&scoped=true"
import script from "./images.vue?vue&type=script&lang=ts"
export * from "./images.vue?vue&type=script&lang=ts"
import style0 from "./images.vue?vue&type=style&index=0&id=105bde4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105bde4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('105bde4e')) {
      api.createRecord('105bde4e', component.options)
    } else {
      api.reload('105bde4e', component.options)
    }
    module.hot.accept("./images.vue?vue&type=template&id=105bde4e&scoped=true", function () {
      api.rerender('105bde4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/images.vue"
export default component.exports